<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Van Campen is concerned with human and non-human life, the environment and social cohesion. Having travelled the world, he physically experienced and survived an Exocet attack in Iran, worked under military protection in Angola during the civil war fought over diamonds and oil, witnessed the chaos of Kinshasa, walked the dirty streets of Lagos and obeyed orders to stay indoors during curfew in Abidjan when the first civil war started. He understands that economic interests will never allow democratic consultation by the people. Through this story, he offers a scientifically sound solution to end the Congo conflict over mineral resources.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?aeffe2be